export function findTabStop(el: HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement | HTMLAnchorElement | HTMLButtonElement, position: 'next' | 'current') {
  const universe = document.querySelectorAll('input, button, select, textarea, a[href]');
  const list = Array.prototype.filter.call(universe, function(item) {return item.tabIndex >= '0';});
  const index = list.indexOf(el);
  return position === 'next' ? list[index + 1] || list[0] : list[index] || list[0];
}